const BASE_URL = `${process.env.REACT_APP_API_BASE}/waitlist`;

const UTM_KEYS = ["source", "medium", "campaign", "term", "content"];
const UTM_STORAGE_KEY = "nf_utm";

/**
 * Capture UTM params from the URL and persist them in sessionStorage.
 * On subsequent calls (e.g. after the user scrolls to a different form),
 * the stored values are returned even if the query string was stripped.
 */
const getUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = UTM_KEYS.reduce((acc, key) => {
    const value = params.get(`utm_${key}`);
    return value ? { ...acc, [key]: value } : acc;
  }, {});

  // Persist new UTMs when present in the URL
  if (Object.keys(fromUrl).length) {
    try {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl));
    } catch {
      /* private browsing — ignore */
    }
    return fromUrl;
  }

  // Fall back to previously stored UTMs
  try {
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

/**
 * Submit a waitlist signup.
 *
 * @param {{ email: string }} data
 */
export const submit = async ({ email }) => {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, utm: getUtmParams() }),
  });

  if (!res.ok) {
    throw new Error("Failed to submit. Please try again.");
  }
};

const client = { submit };
export default client;
